<template>
  <div class="map-container">
    <div class="map" id="map">
    </div>
  </div>

</template>

<script>
export default {
  name: "Map",
  props: {},
  mounted() {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoic2Vrdm9pYSIsImEiOiJjamp6azVxcjgwM2ZyM3FvNjY3aHo5ZGFoIn0.SIDnvkFhqBfw230uf6pZ8Q";
    var map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/dark-v9"
    });
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.map-container {
  width: 310px;
  height: 175px;
  overflow: hidden;
}
.map {
  width: 310px;
  height: 175px;
}
</style>


            